module.exports = __webpack_public_path__ + "static/img/yingxiao_icon2.ff9dac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/yingxiao_icon2.png
// module id = /d2O
// module chunks = 0